<template>
  <template v-if="!model.vars.hideModel">
    <TitleTypeComponent v-if="isTitleType()" :model="model" />
    <SubTitleTypeComponent v-if="isSubTitleType()" :model="model" />
    <ModalInformationTypeComponent v-if="isModalInformationType()" :model="model" />
    <MailStatusTypeComponent v-if="isMailStatusType()" :model="model" />
    <InputTypeComponent
      v-if="isInputType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
      @input="input"
      @buttonAction="buttonAction"
      @buttonClick="buttonClick"
    />
    <SliderTypeComponent
      v-if="isSliderType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
      @input="input"
    />
    <ColorPickerComponent v-if="isColorType()" :model="model" @draft="draft" @focus="focus(model)" @update="update" />
    <IconPickerComponent v-if="isIconType()" :model="model" @draft="draft" @focus="focus(model)" @update="update" />
    <PhoneTypeComponent
      v-if="isPhoneType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
    />
    <TextareaTypeComponent
      v-if="isTextareaType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
    />
    <EditorTypeComponent
      v-if="isEditorType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
      @editorAction="(payload) => $emit('editorAction', payload)"
    />
    <DateTypeComponent
      v-if="isDateType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
      @dateChanged="dateChanged"
    />
    <RadioTypeComponent
      v-if="isRadioType()"
      :index="index"
      :model="model"
      @draft="draft"
      @update="update"
      @toggle="toggle"
    />
    <SwitchTypeComponent
      v-if="isSwitchType()"
      :index="index"
      :model="model"
      @draft="draft"
      @update="update"
      @toggle="toggle"
    />
    <CheckboxTypeComponent
      v-if="isCheckboxType()"
      :index="index"
      :model="model"
      :isMultipleCheckbox="isMultipleCheckbox"
      :isFiltered="isFiltered"
      @draft="draft"
      @update="update"
      @toggle="toggle"
      @filter="filter"
      @resetFilter="resetFilter"
    />
    <SelectTypeComponent
      v-if="isSelectType()"
      :index="index"
      :model="model"
      @ajaxTargetLoad="ajaxTargetLoad"
      @ajaxTargetTrig="ajaxTargetTrig"
      @resetInputs="resetInputs"
      @draft="draft"
      @update="update"
      @toggle="toggle"
      @selected="selected"
      @addEditAction="addEditAction"
      @selectTypeAction="selectTypeAction"
    />
    <ArrayChoicesTypeComponent v-if="isArrayChoicesType()" :index="index" :model="model" />
    <FileTypeComponent
      v-if="isFileType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
      @uploading="uploading"
      @uploaded="uploaded"
      @askRemove="askRemove"
    />
    <ListTypeComponent
      v-if="isListType()"
      :index="index"
      :model="model"
      @draft="draft"
      @focus="focus(model)"
      @update="update"
    />
    <CollectionTypeComponent
      v-if="isCollectionType() && !isApprenticeSalariesCollectionType()"
      :models="model"
      @ajaxTargetLoad="ajaxTargetLoad"
      @ajaxTargetTrig="ajaxTargetTrig"
      @toggle="toggle"
      @draft="draft"
      @update="update"
      @sortCollection="sortCollection"
    />
    <RoleTypeComponent v-if="isRoleType()" :index="index" :model="model" @update="update" />
    <TemplateVariableTypeComponent :model="model" v-if="isTemplateVariableType()" />
    <RegistrationApprenticeSalaryTableComponent
      :model="model"
      v-if="isApprenticeSalariesCollectionType()"
      @draft="draft"
      @tableClickAction="tableClickAction"
    />
  </template>
  <div class="w-100" v-if="isFormType()">
    <button
      type="button"
      @click="expand"
      class="moreFields textStyle"
      v-if="model.vars.attr && model.vars.attr['data-form-more'] && !expanded"
    >
      <span>{{ $t("see_more_fields") }}</span>
    </button>
    <div
      :class="'row' + (model.vars.attr && model.vars.attr['data-form-more'] ? ' more' + (expanded ? ' on' : '') : '')"
    >
      <template v-for="child in model.children" :key="child.vars.id">
        <div v-if="child.vars.line_break" class="col-12"></div>
        <div
          v-if="!child.vars.attr || !child.vars.attr['data-form-sticky']"
          :class="
            'form-group ' +
            (child.vars.row_attr && child.vars.row_attr.class ? ' ' + child.vars.row_attr.class : '') +
            (child.vars.toggle_class ? ' d-none ' + child.vars.toggle_class.replaceAll('\\', '') : '')
          "
        >
          <ModelComponent :model="child" />
        </div>
      </template>
    </div>
  </div>
  <FormAlertsComponent
    v-if="triggeredAlerts.length && !model.vars.hideModel"
    :alerts="triggeredAlerts"
    :name="model.vars.name"
    @toggleTab="toggleTab"
  />
</template>

<script>
import InputTypeComponent from "@/components/form/InputTypeComponent.vue";
import TextareaTypeComponent from "@/components/form/TextareaTypeComponent.vue";
import DateTypeComponent from "@/components/form/DateTypeComponent.vue";
import RadioTypeComponent from "@/components/form/RadioTypeComponent.vue";
import CheckboxTypeComponent from "@/components/form/CheckboxTypeComponent.vue";
import FileTypeComponent from "@/components/form/FileTypeComponent.vue";
import SelectTypeComponent from "@/components/form/SelectTypeComponent.vue";
import EditorTypeComponent from "@/components/form/EditorTypeComponent.vue";
import ListTypeComponent from "@/components/form/ListTypeComponent.vue";
import SwitchTypeComponent from "@/components/form/SwitchTypeComponent.vue";
import PhoneTypeComponent from "@/components/form/PhoneTypeComponent.vue";
import { formManager } from "@/services/form/form-manager";
import RoleTypeComponent from "@/components/form/RoleTypeComponent.vue";
import TemplateVariableTypeComponent from "@/components/form/TemplateVariableTypeComponent.vue";
import TitleTypeComponent from "@/components/form/TitleTypeComponent.vue";
import SubTitleTypeComponent from "@/components/form/SubTitleTypeComponent.vue";
import ArrayChoicesTypeComponent from "@/components/form/ArrayChoicesTypeComponent.vue";
import ModalInformationTypeComponent from "@/components/form/ModalInformationTypeComponent.vue";
import MailStatusTypeComponent from "@/components/form/MailStatusTypeComponent.vue";
import RegistrationApprenticeSalaryTableComponent from "@/components/registration/salary/RegistrationApprenticeSalaryTableComponent.vue";
import CollectionTypeComponent from "@/components/form/CollectionTypeComponent.vue";
import { mapActions } from "pinia";
import { useFormStore } from "@/store/form/form";
import FormAlertsComponent from "@/components/form/alert/FormAlertsComponent.vue";
import SliderTypeComponent from "@/components/form/SliderTypeComponent.vue";
import { injectionKeysConstante } from "@/constantes/injection-keys";
import ColorPickerComponent from "@/components/form/ColorPickerComponent.vue";
import IconPickerComponent from "@/components/form/IconPickerComponent.vue";

export default {
  name: "ModelComponent",
  emits: [
    "resetFilter",
    "input",
    "ajaxTargetLoad",
    "ajaxTargetTrig",
    "update",
    "toggle",
    "uploading",
    "uploaded",
    "dateChanged",
    "resetInputs",
    "draft",
    "focus",
    "focused",
    "selected",
    "sortCollection",
    "addEditAction",
    "filter",
    "toggleTab",
    "selectTypeAction",
    "buttonAction",
    "buttonClick",
    "fetchConditionalChildren",
    "askRemove",
    "editorAction",
    "tableClickAction",
  ],
  components: {
    ColorPickerComponent,
    IconPickerComponent,
    SliderTypeComponent,
    FormAlertsComponent,
    CollectionTypeComponent,
    RegistrationApprenticeSalaryTableComponent,
    ModalInformationTypeComponent,
    MailStatusTypeComponent,
    ArrayChoicesTypeComponent,
    SubTitleTypeComponent,
    TitleTypeComponent,
    TemplateVariableTypeComponent,
    RoleTypeComponent,
    PhoneTypeComponent,
    SwitchTypeComponent,
    ListTypeComponent,
    EditorTypeComponent,
    SelectTypeComponent,
    FileTypeComponent,
    CheckboxTypeComponent,
    RadioTypeComponent,
    TextareaTypeComponent,
    InputTypeComponent,
    DateTypeComponent,
  },
  inject: {
    isFocusScrollDisabled: {
      from: injectionKeysConstante.FOCUS_SCROLL_DISABLED,
      default: () => () => false,
    },
  },
  data() {
    return {
      errors: [],
      formModel: this.model,
      expanded: false,
    };
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
    disableFocusAnimation: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMultipleCheckbox: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFiltered: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    triggeredAlerts() {
      let triggeredAlerts = [];
      const alerts = this.model?.vars?.attr?.alerts;
      if (alerts) {
        triggeredAlerts = alerts.filter((alert) => alert.isTriggered === true);
      }
      return triggeredAlerts;
    },
  },
  mounted() {
    if (this.model.vars.attr && this.model.vars.attr["data-ajax-load"]) {
      formManager.fieldLoad(this.model, this, this.model.vars.value ? this.model.vars.value.value : null);
    }
    this.setSearchAjaxChildrenCorrespondingTable();
    this.fetchConditionalChildren(true);
  },
  methods: {
    isTitleType() {
      return formManager.isTitleType(this.model);
    },

    isSubTitleType() {
      return formManager.isSubTitleType(this.model);
    },

    isModalInformationType() {
      return formManager.isModalInformationType(this.model);
    },

    isMailStatusType() {
      return formManager.isMailStatusType(this.model);
    },

    isInputType() {
      return formManager.isInputType(this.model);
    },

    isColorType() {
      return formManager.isColorType(this.model);
    },

    isIconType() {
      return formManager.isIconType(this.model);
    },

    isPhoneType() {
      return formManager.isPhoneType(this.model);
    },

    isTextareaType() {
      return formManager.isTextareaType(this.model);
    },

    isEditorType() {
      return formManager.isEditorType(this.model);
    },

    isDateType() {
      return formManager.isDateType(this.model);
    },

    isRadioType() {
      return formManager.isRadioType(this.model);
    },

    isSwitchType() {
      return formManager.isSwitchType(this.model);
    },

    isCheckboxType() {
      return formManager.isCheckboxType(this.model);
    },

    isSelectType() {
      return formManager.isSelectType(this.model);
    },

    isArrayChoicesType() {
      return formManager.isArrayChoicesType(this.model);
    },

    isTemplateVariableType() {
      return formManager.isTemplateVariableType(this.model);
    },

    isFileType() {
      return formManager.isFileType(this.model);
    },

    isListType() {
      return formManager.isListType(this.model);
    },

    isSliderType() {
      return formManager.isSliderType(this.model);
    },

    isRoleType() {
      return formManager.isRoleType(this.model);
    },

    isFormType() {
      return formManager.isFormType(this.model);
    },
    isCollectionType() {
      return formManager.isCollectionType(this.model);
    },

    isApprenticeSalariesCollectionType() {
      return formManager.isApprenticeSalariesCollectionType(this.model);
    },

    focus(item) {
      if (window.innerWidth > 768 && !this.disableFocusAnimation) {
        let group;
        if (item.vars.block_prefixes[1] !== "checkbox" && item.vars.block_prefixes[1] !== "radio") {
          const input = document.getElementById(item.vars.id);
          if (input) {
            group = input.parentNode;
          }
        } else {
          group = document.getElementById(item.id);
        }

        this.$emit("focused", item.vars.id);

        if (group && !this.isFocusScrollDisabled()) {
          setTimeout(function () {
            window.scrollTo({
              behavior: "smooth",
              top: group.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 250,
            });
          }, 1);
        }
      }
    },

    expand() {
      this.expanded = true;
    },

    draft(model) {
      this.$emit("draft", model);
    },

    tableClickAction(url) {
      this.$emit("tableClickAction", url);
    },

    selected(model) {
      this.$emit("selected", model);
    },
    update(value) {
      this.setSearchAjaxChildrenCorrespondingTable();
      this.fetchConditionalChildren();
      this.$emit("update", { value: value, model: this.model });
    },
    dateChanged(model) {
      this.$emit("dateChanged", model);
    },
    input(value) {
      this.$emit("input", value);
    },
    toggle(model) {
      this.$emit("toggle", model);
    },
    ajaxTargetLoad(payload) {
      this.$emit("ajaxTargetLoad", { ...payload, parent: this.model.vars.name });
    },
    ajaxTargetTrig(payload) {
      this.$emit("ajaxTargetTrig", payload);
    },
    uploading() {
      this.$emit("uploading");
    },
    uploaded(data) {
      this.$emit("uploaded", data);
    },
    askRemove(data) {
      this.$emit("askRemove", data);
    },
    sortCollection() {
      this.$emit("sortCollection");
    },
    resetInputs(payload) {
      this.$emit("resetInputs", payload);
    },
    filter(payload) {
      this.$emit("filter", payload);
    },
    resetFilter() {
      this.$emit("resetFilter");
    },

    addEditAction(payload) {
      this.$emit("addEditAction", payload);
    },

    toggleTab(payload) {
      this.$emit("toggleTab", payload);
    },
    buttonAction(payload) {
      this.$emit("buttonAction", payload);
    },

    selectTypeAction(payload) {
      this.$emit("selectTypeAction", payload);
    },

    buttonClick(payload) {
      this.$emit("buttonClick", payload);
    },

    setSearchAjaxChildrenCorrespondingTable() {
      if (
        this.formModel.vars?.attr &&
        this.formModel.vars.attr["data-ajax-children"] &&
        this.formModel.vars.attr["data-ajax-children"].length
      ) {
        const value =
          this.formModel.vars.value?.value !== undefined ? this.formModel.vars.value.value : this.formModel.vars.value;

        this.formModel.vars.attr["data-ajax-children"].forEach((children) => {
          this.addChildrenToParentAjaxParamsCorrespondingTable(children, value, this.formModel.vars.name);
        });
      }
    },

    fetchConditionalChildren(init = false) {
      if (
        this.model?.vars?.attr &&
        this.model.vars.attr["conditionalChildren"] &&
        this.model.vars.attr["conditionalChildren"].length
      ) {
        this.$emit("fetchConditionalChildren", { model: this.model, init: init });
      }
    },

    ...mapActions(useFormStore, ["addChildrenToParentAjaxParamsCorrespondingTable"]),
  },
};
</script>

<style lang="scss" scoped>
.non-empty {
  overflow: auto;
}

.more {
  max-height: 0;
  overflow: hidden;
  transition: max-height 300ms ease-in-out;

  &.on {
    max-height: 10000px;
  }
}

.moreFields {
  background: none;
  border: none;
  display: block;
  width: 100%;
  text-align: center;
  padding: 7px 0;
  position: relative;
  font-size: 15px;
  font-weight: 700;

  span {
    background: $white;
    position: relative;
    z-index: 2;
    padding: 0 25px;

    @include dark-theme {
      background: $m-color_10;
    }
  }

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: $admin-color;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;

    @include dark-theme {
      background-color: $dark-grey;
    }
  }
}
</style>
